import { useMemo } from 'preact/hooks';
import { useFilter } from '../../contexts/FilterContext';
import type { Currency } from '../../types/api';
import { HeaderFilterSelect, type HeaderFilterOption } from './HeaderFilterSelect';

function getCurrencyLabel(currency: Currency): string {
  if (currency.symbol && currency.currency) {
    return `${currency.symbol} ${currency.currency}`;
  }
  if (currency.currency_name && currency.currency) {
    return `${currency.currency_name} (${currency.currency})`;
  }
  return currency.currency || 'Unknown Currency';
}

export const CurrencyFilter = () => {
  const { selectedCurrency, currencies, loading, setCurrency } = useFilter();

  const options = useMemo<HeaderFilterOption<Currency>[]>(
    () =>
      currencies.map((currency, index) => ({
        key: currency.currency || currency.iso_code || String(index),
        label: getCurrencyLabel(currency),
        searchText: [
          currency.currency,
          currency.currency_name,
          currency.symbol,
          currency.iso_code,
        ]
          .filter(Boolean)
          .join(' '),
        value: currency,
      })),
    [currencies],
  );

  return (
    <HeaderFilterSelect
      ariaLabel="Currency"
      valueLabel={selectedCurrency ? getCurrencyLabel(selectedCurrency) : 'Currency'}
      options={options}
      selectedKey={selectedCurrency?.currency || selectedCurrency?.iso_code}
      disabled={loading}
      searchable
      onSelect={setCurrency}
    />
  );
};
